import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Logo from "./Logo";
import {
  SignedIn,
  SignedOut,
  SignInButton,
  SignUpButton,
  UserButton,
} from "@clerk/clerk-react";

const Navbar = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";

  const scrollToSection = (id: string) => {
    if (!isLandingPage) {
      // If not on landing, navigate to landing with hash
      window.location.href = `/#${id}`;
      return;
    }
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-b border-border/50">
      <div className="container mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/">
          <Logo />
        </Link>

        <div className="hidden md:flex items-center gap-6 absolute left-1/2 -translate-x-1/2">
          <Button variant="ghost-gold" onClick={() => scrollToSection("features")}>
            Features
          </Button>
          <Button variant="ghost-gold" asChild>
            <Link to="/pricing">Pricing</Link>
          </Button>
          <Button variant="ghost-gold" onClick={() => scrollToSection("testimonials")}>
            Testimonials
          </Button>
          <Button variant="ghost-gold" onClick={() => scrollToSection("case-studies")}>
            Case Studies
          </Button>
        </div>

        <div className="flex items-center gap-3">
          <SignedOut>
            <SignInButton mode="redirect">
              <Button variant="secondary" size="sm">
                Login
              </Button>
            </SignInButton>
            <SignUpButton mode="redirect">
              <Button variant="default" size="sm">
                Sign Up
              </Button>
            </SignUpButton>
          </SignedOut>
          <SignedIn>
            <Button variant="secondary" size="sm" asChild>
              <Link to="/app">Dashboard</Link>
            </Button>
            <UserButton afterSignOutUrl="/" />
          </SignedIn>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
